import { render, staticRenderFns } from "./AgTableSwitchCell.vue?vue&type=template&id=dec9d01c&scoped=true&"
import script from "./AgTableSwitchCell.vue?vue&type=script&lang=js&"
export * from "./AgTableSwitchCell.vue?vue&type=script&lang=js&"
import style0 from "./AgTableSwitchCell.vue?vue&type=style&index=0&id=dec9d01c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec9d01c",
  null
  
)

export default component.exports